const ALL_WORDS = 'Max Words';
const NEW_WORDS = 'New Words(Always Less or Equal then Max)';

export const switchers = [
  {
    name: 'translate',
    label: 'Show word translate',
    color: 'primary',
  },
  {
    name: 'transcription',
    label: 'Show word transcription',
    color: 'primary',
  },
  {
    name: 'image',
    label: 'Show word image',
    color: 'primary',
  },
  {
    name: 'description',
    label: 'Show word description',
    color: 'primary',
  },
  {
    name: 'example',
    label: 'Show word example',
    color: 'primary',
  },
];

export { ALL_WORDS, NEW_WORDS };